import { useSelector } from 'react-redux';
import { RootState } from 'store';

export const getHasFeatureAccess =
  (featureName: string) =>
  (state: RootState): boolean =>
    state.publisher?.publisherFeatures?.[featureName]?.includes(state.environment?.environmentId) ?? false;

export const useHasFeatureAccess = (featureName: string): boolean => {
  return useSelector(getHasFeatureAccess(featureName));
};
